import type { TRecurrenceButtonActions } from "../types";

type TRecurrenceButtonProps = {
  wrapperClass: string;
  textClass: string;
};

type TRecurrenceVariantProps = {
  [key in TRecurrenceButtonActions]: TRecurrenceButtonProps;
};

export const recurrenceVariants: TRecurrenceVariantProps = {
  active: {
    wrapperClass: "bg-blue-500 relative z-10",
    textClass: "text-white",
  },
  inactive: {
    wrapperClass: "bg-blue-50 relative z-0",
    textClass: "text-gray-450",
  },
};
